import React from 'react';
import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css';

const DesktopNavbar2= () => {

  useEffect(() => {
        Aos.init({ duration: 1000 });
      }, []);

  const navigate = useNavigate();
  const navi = useNavigate();

  const handleScrollToSection = (sectionId) => {
    navigate('/');
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.warn(`Section with ID "${sectionId}" not found`);
      }
    }, 0);
  };


  return (
    <div>
      <nav  className="ml-4 mr-10 font-inria border-b ">
        <div className="container mx-auto flex items-center justify-between">
        <div data-aos="zoom-in">
           <svg className='h-20 w-40' xmlns="http://www.w3.org/2000/svg">
             <g>
              <ellipse cx="60" cy="40" rx="60" ry="30" width="50" height="50" stroke='#5B5D60' fill="#242424"></ellipse>
              <text x="25" y="50" font-family="Imperial Script" font-size="50" fill="white">Siri</text>
             </g>
          </svg>
         </div>
         <div className="flex space-x-8 text-xl text-white" data-aos="fade-left">
          <button className='focus:outline-none font-bold'
          onClick={() => handleScrollToSection('home')}
          >Home
          </button>
          <button className='focus:outline-none font-bold'
          onClick={() => handleScrollToSection('about')}
          >About
          </button>
          <button className='focus:outline-none font-bold'
          onClick={() => handleScrollToSection('work')}
          >Work
          </button>
          <button className='font-bold focus:outline-none relative ' 
          onClick={()=>(navi('/certificate'))}
          >Certificate
           <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-[#E4B379] rounded-full"></div>
          </button>
          <button className='focus:outline-none font-bold'
          onClick={() => handleScrollToSection('contact')}
          >Contact
          </button>
          <a href='https://drive.google.com/file/d/1gFcsHlZdlHtw7ykG2uDTRMfc08ZllRcj/view?usp=sharing' target='/blank'>
          <button className='hover:font-bold'>
            Resume           
          </button></a>
         </div>
        </div>
      </nav>
    </div>
  )
}

const MobileNavbar2 = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const navi = useNavigate();

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleScrollToSection = (sectionId) => {
    navigate('/');
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.warn(`Section with ID "${sectionId}" not found`);
      }
    }, 0);
  };
  useEffect(() => {
    if (isDrawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isDrawerOpen]);
 

  return (
    <nav className='flex justify-between items-center top-0 z-50 fixed w-full pt-3' style={{ backgroundColor: '#242424' }}>
      <div data-aos="zoom-in">
           <svg className='h-20 w-40' xmlns="http://www.w3.org/2000/svg">
             <g>
              <ellipse cx="60" cy="40" rx="60" ry="30" width="50" height="50" stroke='#5B5D60' fill="#242424"></ellipse>
              <text x="25" y="50" font-family="Imperial Script" font-size="50" fill="white">Siri</text>
             </g>
          </svg>
         </div>
      <button className="md:hidden block mx-3 z-50" onClick={toggleDrawer}>
        {isDrawerOpen ? (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        ) : (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        )}
      </button>
      {isDrawerOpen && (
        <div className="md:hidden fixed inset-0 bg-[#242424] bg-opacity-95 z-40">
        <div className="flex flex-col pt-10 text-xl text-white" data-aos="fade-left">
        <button className='focus:outline-none font-bold'
        onClick={() => handleScrollToSection('home')}
        >Home
        </button>
        <button className='focus:outline-none font-bold pt-2'
        onClick={() => handleScrollToSection('about')}
        >About
        </button>
        <button className='focus:outline-none font-bold pt-2'
        onClick={() => handleScrollToSection('work')}
        >Work
        </button>
        <button className=' flex justify-center font-bold focus:outline-none relative pt-2' 
        onClick={()=>(navi('/certificate'))}
        >Certificate
         <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-[#E4B379] rounded-full"></div>
        </button>
        <button className='focus:outline-none font-bold pt-4'
        onClick={() => handleScrollToSection('contact')}
        >Contact
        </button>
        <a href='https://drive.google.com/file/d/1gFcsHlZdlHtw7ykG2uDTRMfc08ZllRcj/view?usp=sharing' target='/blank' className='flex justify-center pt-2'>
        <button className='hover:font-bold'>
          Resume           
        </button></a>
       </div>
       </div>
      )}
    </nav>
  )
}


const Navbar2 = () => {
  return (
    <div>
      <div className='hidden md:block'>
        {/* Show Desktop Navbar2 for screens larger than or equal to medium (md) */}
        <DesktopNavbar2 />
      </div>

      {/* Show Mobile Navbar2 for screens smaller than medium (md) */}
      <div className='md:hidden block'>
        <MobileNavbar2 />
      </div>
    </div>
  );
};

export default Navbar2;
